/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IndividualAccount } from './IndividualAccount';
import {
    IndividualAccountFromJSON,
    IndividualAccountFromJSONTyped,
    IndividualAccountToJSON,
} from './IndividualAccount';

/**
 * 
 * @export
 * @interface UpdateIndividualAccountDetailsOutput
 */
export interface UpdateIndividualAccountDetailsOutput {
    /**
     * 
     * @type {IndividualAccount}
     * @memberof UpdateIndividualAccountDetailsOutput
     */
    account?: IndividualAccount;
    /**
     * 
     * @type {Error}
     * @memberof UpdateIndividualAccountDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UpdateIndividualAccountDetailsOutput interface.
 */
export function instanceOfUpdateIndividualAccountDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateIndividualAccountDetailsOutputFromJSON(json: any): UpdateIndividualAccountDetailsOutput {
    return UpdateIndividualAccountDetailsOutputFromJSONTyped(json, false);
}

export function UpdateIndividualAccountDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIndividualAccountDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : IndividualAccountFromJSON(json['account']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UpdateIndividualAccountDetailsOutputToJSON(value?: UpdateIndividualAccountDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': IndividualAccountToJSON(value.account),
        'error': value.error,
    };
}

